import { createAction, props } from "@ngrx/store";
import { IsNumber } from "class-validator";

/**
 * Load Generic Collection Actions
 */

export const loadIncidenceGenericWithoutId = (actionType: string) =>
  createAction(
    `[${actionType}] Load Incidence ${actionType} WithoutId Load`,
    props<{ modelType: string }>(),
  );

export const loadIncidenceGenericWithoutIdSuccess = (actionType: string) =>
  createAction(
    `[${actionType}] Load Incidence ${actionType} WithoutId Data Success`,
    props<{ returnedData: any[] }>(),
  );

export const loadIncidenceGenericWithoutIdFailure = (actionType: string) =>
  createAction(
    `[${actionType}] Load Incidence ${actionType} WithoutId Data Failure`,
    props<{ error: any }>(),
  );


  /**
 * Load Generic Collection Actions
 */

export const loadIncidenceGeneric = (actionType: string) =>
createAction(
  `[${actionType}] Load Incidence ${actionType} Load`,
  props<{ modelType: string, id: string }>(),
);

export const loadIncidenceGenericSuccess = (actionType: string) =>
createAction(
  `[${actionType}] Load Incidence ${actionType} Data Success`,
  props<{ returnedData: any[] }>(),
);

export const loadIncidenceGenericFailure = (actionType: string) =>
createAction(
  `[${actionType}] Load Incidence ${actionType} Data Failure`,
  props<{ error: any }>(),
);


export const loadIncidenceByIdGeneric = (actionType: string) =>
  createAction(
    `[${actionType}] Load Incidence ${actionType} Data`,
    props<{ modelType: string; id: string }>(),
  );

export const loadIncidenceByIdGenericSuccess = (actionType: string) =>
  createAction(
    `[${actionType}] Load Incidence ${actionType} Data Success`,
    props<{ returnedData: any[] }>(),
  );

export const loadIncidenceByIdGenericFailure = (actionType: string) =>
  createAction(
    `[${actionType}] Load Incidence ${actionType} Data Failure`,
    props<{ error: any }>(),
  );

export const addIncidenceGeneric = (actionType: string) =>
  createAction(
    `[${actionType}] Add Incidence ${actionType} Data`,
    props<{ dataToAdd: any[]; modelType: string }>(),
  );

export const addIncidenceGenericSuccess = (actionType: string) =>
  createAction(
    `[${actionType}] Add Incidence ${actionType} Data Success`,
    props<{ returnedData: any[] }>(),
  );

export const addIncidenceGenericFailure = (actionType: string) =>
  createAction(
    `[${actionType}] Add Incidence ${actionType} Data Failure`,
    props<{ error: any }>(),
  );

export const removeIncidenceGeneric = (actionType: string) =>
  createAction(
    `[${actionType}] Remove Incidence ${actionType} Data`,
    props<{ ids: string[]; modelType: string }>(),
  );

export const removeIncidenceGenericSuccess = (actionType: string) =>
  createAction(
    `[${actionType}] Remove Incidence ${actionType} Data Success`,
    props<{ ids: string[] }>(),
  );

export const removeIncidenceGenericFailure = (actionType: string) =>
  createAction(
    `[${actionType}] Remove Incidence ${actionType} Data Failure`,
    props<{ error: any }>(),
  );

export const updateIncidenceGeneric = (actionType: string) =>
  createAction(
    `[${actionType}] Update Incidence ${actionType} Data`,
    props<{ dataToAdd: any[]; deletedData: any[]; modelType: string }>(),
  );

export const updateIncidenceGenericSuccess = (actionType: string) =>
  createAction(
    `[${actionType}] Update Incidence ${actionType} Data Success`,
    props<{ returnedData: any[] }>(),
  );

export const updateIncidenceGenericFailure = (actionType: string) =>
  createAction(
    `[${actionType}] Update Incidence ${actionType} Data Failure`,
    props<{ error: any }>(),
  );


  export const loadIncidenceGenericClearState = (actionType: string) =>
  createAction(
    `[${actionType}] CLear Incidence ${actionType}  CLear State`,
    props<{ modelType: any }>(),
  );

export const loadIncidenceGenericClearStateSuccess = (actionType: string) =>
  createAction(
    `[${actionType}] CLear Incidence ${actionType}  CLear State Success`,
    props<{ returnedData: any[] }>(),
  );

